
import { Component, Vue, Prop } from 'vue-property-decorator'
import type { SharePopupParams } from './index.vue'
import Price from '@/components/Price/index.vue'
import { handleFill, handleAmount } from '@/utils/util'

@Component({
  components: { Price }
})
class ProductShareCard extends Vue {
  @Prop({ required: true }) data!: SharePopupParams
  handleFill = handleFill
  handleAmount = handleAmount

  /** 只取第一张图，没有图片时使用默认图 */
  get displayImage (): string {
    // 默认使用 default-img1.png
    const defaultImg = require('@/assets/images/wordChain/default-img1.png')
    if (!this.data.images || this.data.images.length === 0) {
      return defaultImg
    }
    return this.data.images[0]
  }
}

export default ProductShareCard
